function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("title", null, "Group 10");

var _ref3 = React.createElement("desc", null, "Created with Sketch.");

var _ref4 = React.createElement("defs", null);

var _ref5 = React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Artboard",
  transform: "translate(-149.000000, -932.000000)",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-10",
  transform: "translate(149.000000, 932.000000)"
}, React.createElement("g", {
  id: "passenger_add_adult-copy"
}, React.createElement("circle", {
  id: "Oval",
  fill: "#004152",
  cx: 17.4109589,
  cy: 17.4041096,
  r: 17.3835616
}), React.createElement("path", {
  d: "M23.0616438,6.99315068 C21.8356164,5.56849315 19.9794521,5.17808219 17.5205479,5.76027397 C14.9383562,5.82191781 13.0753425,6.59589041 11.9794521,8.15068493 C10.0410959,10.869863 11.0753425,14.7945205 11.3356164,15.7671233 C10.760274,17.630137 11.8561644,18.9863014 12.1164384,19.2465753 C12.3767123,19.5684932 15.2876712,23.8219178 12.8287671,26.4109589 L11.9863014,26.7945205 C10.0821918,27.6643836 8.12328767,28.6232877 6.65753425,29.5136986 C9.52054795,32.0547945 13.2808219,33.5958904 17.4109589,33.5958904 C21.2465753,33.5958904 24.7739726,32.260274 27.5479452,30.0273973 C26.0547945,28.7465753 24.4520548,27.6164384 22.7465753,26.3561644 C22.4794521,26.1575342 22.1780822,25.9109589 21.869863,25.6369863 C21.1575342,24.2123288 21.9589041,22.3424658 23.1164384,20.2808219 C23.3150685,19.8972603 23.5068493,19.5 23.6986301,19.1164384 C24.739726,17 24.5342466,15.6438356 24.4109589,15.1232877 C24.8767123,13.5753425 25.1986301,9.32191781 23.0616438,6.99315068 Z",
  id: "Shape",
  fill: "#FFFFFF"
})), React.createElement("path", {
  d: "M17.4728665,28.4214803 C17.0438677,30.9750602 16.6999969,33.9052294 16.6999969,33.9052294 L19.1969315,33.9052294 C19.1969315,33.9052294 18.6851969,30.623056 18.2621943,27.9596187 L19.6969151,26 L15.6999969,26 L17.4728665,28.4214803 Z",
  id: "Combined-Shape-Copy",
  fill: "#004152"
}))));

var SvgCustomerInCircle = function SvgCustomerInCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCustomerInCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/customer-in-circle.2750c86c.svg";
export { ForwardRef as ReactComponent };